// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hover\\:bg-secondary-100[data-v-3e6696cd]:hover {\n  background: #1a7bee;\n}\n.disabled[data-v-3e6696cd] {\n  background: rgba(159, 166, 178, 0.3882352941);\n  cursor: not-allowed;\n  color: #9fa6b2;\n}", ""]);
// Exports
module.exports = exports;
